module.exports = __webpack_public_path__ + "img/casinot-image-box.6a0af90d.jpg";